<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between d-flex">
            &#xca;tes-vous sûr(e) de vouloir l'associer à un {{ getCurrentAccountTitle }}?
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <v-card-text>
            <v-layout wrap xs12>
                <v-select-filled
                    :items="currentAccountUsers"
                    :item-title="getUserDisplayName"
                    item-value="id"
                    label="Associé"
                    v-model="currentAccountUser"
                    return-object
                    outlined
                    :readonly="currentAccountUsers.length <= 1"
                />
            </v-layout>
        </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn rounded @click="linkWithCurrentAccount" :loading="loading" size="small"
                >Oui, je suis sûr(e)</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";

import { User } from "../../../../types";
import { getUserDisplayName } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "cancel"],
})
export class CurrentAccount extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) btItem: any;
    @Prop({ default: "" }) accountableAccount: string;
    @Prop({ default: null }) actions: any;

    loading: boolean = false;

    get getCurrentAccountTitle() {
        let title = "";
        if (this.accountableAccount === "455000")
            title = this.$t("reconciliation.action.CURRENT_ACCOUNT").toString();
        else if (this.accountableAccount === "108000")
            title = this.$t("reconciliation.action.OPERATOR_ACCOUNT").toString();
        else if (this.accountableAccount === "467000")
            title = this.$t("reconciliation.action.DEBIT_CREDIT_ACCOUNT").toString();
        if (title) {
            return title.toLowerCase();
        }
        return "XXX";
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            // this.actions.action.disabled = () => {return !this.disabledAddLoanValidate}
            this.actions.action.function = this.linkWithCurrentAccount;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    currentAccountUser: User = null;

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    if (this.currentAccountUsers.length) {
                        this.currentAccountUser = this.currentAccountUsers[0];
                    }
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    // get defaultAccountableAccount() {
    //     return this.reconciliationVue.legalForm !== "EI" ? "455000" : "108000";
    // }

    // get accountableAccount() {
    //     if (this._accountableAccount) return this._accountableAccount
    //     return this.defaultAccountableAccount
    // }

    // set accountableAccount(value) {
    //     this._accountableAccount = value
    // }

    async linkWithCurrentAccount() {
        this.loading = true;
        if (this.accountableAccount) {
            await this.reconciliationVue.addCurrentAccount(
                this.currentAccountUser,
                this.accountableAccount,
                this.btItem,
            );
            this.$emit("added", this.currentAccountUser);
        }
        this.loading = false;
    }

    cancel() {
        this.$emit("cancel");
    }
}

export default toNative(CurrentAccount);
</script>
